import { useState } from "react";
import styles from "./Bot.module.scss";
import ChevronDownIcon from "./ChevronDownIcon";

interface Props {
  question: string;
  answer: string;
}

const FaqContent = ({ question, answer }: Props) => {
  const [isOpen, setIsOpen] = useState(false); // State to manage the toggle (open/close)

  const toggleCollapse = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  // Show only one line of the answer, truncating the rest.
  const truncatedAnswer =
    answer.length > 36 ? answer.slice(0, 50) + "..." : answer;

  return (
    <div
      onClick={toggleCollapse}
      className={styles.faqContentWrapper}
      style={{ cursor: "pointer" }}
    >
      <div>
        <div className={styles.faqQuestion}>{question}</div>
        <div className={styles.faqAnswer}>
          {" "}
          {isOpen ? answer : truncatedAnswer}
        </div>
      </div>
      <button
        onClick={toggleCollapse}
        style={{
          background: "transparent",
          border: "none",
          transition: "transform 0.3s",
          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate the arrow on toggle
        }}
      >
        <ChevronDownIcon className={styles.faqButtonIcon} />
      </button>
    </div>
  );
};

export default FaqContent;
